"use strict";

import angular from "angular";

angular.module("nucont.accounting.mySubscription", ["nucont.shared"]);
require("./my-subscription.routes");
